<template>
  <div class="dashboard-block">
    <h2>Market Segments</h2>
    <ul class="item-detail item-detail-profile">
      <li v-for="market_segment in stateMarketSegments" :key="market_segment">
        {{ market_segment | sentenceCase }}
      </li>
    </ul>
  </div>
</template>

<script>
import { stateMapper, helpers } from 'mixins/users'

export default {
  mixins: [stateMapper, helpers]
}
</script>
